import * as yup from 'yup';

import { PermissiblePurposeCreateModalFields } from './types';

export const permissiblePurposeCreateModalFormSchema = yup.object({
  [PermissiblePurposeCreateModalFields.permissiblePurposeReferenceId]: yup
    .string()
    .required('Should choose a permissible purpose'),
});
